import { actionGenerator } from 'shared/utils/redux/actionGenerator';

export enum ENewbuildingBrokerDIYActions {
  SetEnabled = 'newbuildingBrokerDIY/setEnabled',
  SetGalleryBannerAnalyticsSent = 'newbuildingBrokerDIY/setGalleryDIYBannerAnalyticsSent',
}

export const setNewbuildingBrokerDIYEnabled = actionGenerator<ENewbuildingBrokerDIYActions.SetEnabled, boolean>(
  ENewbuildingBrokerDIYActions.SetEnabled,
);

export const setGalleryDIYBannerAnalyticsSent =
  actionGenerator<ENewbuildingBrokerDIYActions.SetGalleryBannerAnalyticsSent>(
    ENewbuildingBrokerDIYActions.SetGalleryBannerAnalyticsSent,
  );

export type TNewbuildingBrokerDIYActions =
  | ReturnType<typeof setNewbuildingBrokerDIYEnabled>
  | ReturnType<typeof setGalleryDIYBannerAnalyticsSent>;
